import { useState } from "react";

/** The model picker's open state and which provider's submenu is showing. */
export function useAgentSelectMenuState() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [hoveredProvider, setHoveredProvider] = useState(null);
  const [hoveredAnchor, setHoveredAnchor] = useState(null);
  return {
    anchorEl,
    hoveredProvider,
    hoveredAnchor,
    open: Boolean(anchorEl),
    openAt: (event) => setAnchorEl(event.currentTarget),
    close: () => {
      setAnchorEl(null);
      setHoveredProvider(null);
      setHoveredAnchor(null);
    },
    enterProvider: (provider, anchor) => {
      setHoveredProvider(provider);
      setHoveredAnchor(anchor);
    },
  };
}
